export default {
  dropdownlist: 'logindropdownlist absolute',
};
